var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 800'%3e%3cpath fill='%23005BBB' d='M0 0h1200v800H0z'/%3e%3cpath fill='%23FFD500' d='M0 400h1200v400H0z'/%3e%3c/svg%3e";
  export default img;